
import { Vue, Component, Prop, PropSync } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import dayjs from 'dayjs'

@Component({
  name: 'log',
  components: {
    SimpleTable
  }
})
export default class Log extends Vue {
  private money (val: any) {
    const dict: any = {
      1: 'actualMoney',
      2: 'refund',
      3: 'actualMoney',
      4: 'reduce'
    }
    return val ? dict[val] : ''
  }

  private tradeType (val:any) {
    const dict: any = {
      1: '收费',
      2: '退费',
      3: '预付',
      4: '减免'
    }
    return val ? dict[val] : ''
  }

  get createTime () {
    return this.data.createTime !== -1 && this.data.createTime !== '-1' ? dayjs(this.data.createTime).format('YYYY-MM-DD HH:mm') : ''
  }

  @PropSync('visible', { type: Boolean })
  private dialogVisible!: boolean

  @Prop({ type: Object })
  private data!: object|any

  private pagination = null

  private tableDatas: any = []

  private columns = [
    {
      prop: '',
      label: '收费项目'
    },
    {
      prop: '',
      label: '收费区间起'
    },
    {
      prop: '',
      label: '收费区间止'
    },
    {
      prop: '',
      label: '必缴'
    },
    {
      prop: '',
      label: '剩余盈余'
    },
    {
      prop: '',
      label: '应收'
    },
    {
      prop: '',
      label: '已收'
    },
    {
      prop: '',
      label: '已减免'
    },
    {
      prop: '',
      label: '现金'
    },
    {
      prop: '',
      label: '刷卡'
    },
    {
      prop: '',
      label: '转账'
    },
    {
      prop: '',
      label: '支付宝'
    },
    {
      prop: '',
      label: '微信'
    },
    {
      prop: '',
      label: '一码通'
    },
    {
      prop: '',
      label: '缴平台'
    },
    {
      prop: '',
      label: '绣推'
    },
    {
      prop: '',
      label: '实收'
    }
  ]

  private option = [
    {
      label: 'oldStuBusinessName',
      value: '业务名称'
    },
    {
      label: 'oldSchoolName',
      value: '院校'
    },
    {
      label: 'oldSubjectName',
      value: '专业'
    },
    {
      label: 'oldGradeName',
      value: '年级'
    },
    {
      label: 'stuBusinessName',
      value: '业务名称'
    },
    {
      label: 'schoolName',
      value: '院校'
    },
    {
      label: 'subjectName',
      value: '专业'
    },
    {
      label: 'gradeName',
      value: '年级'
    },
    {
      label: 'userAlias',
      value: '操作账号'
    },
    {
      label: 'createName',
      value: '操作员'
    },
    {
      label: 'createTime',
      value: '操作时间',
      format: (val: any) => (val && val !== -1 && val !== '-1' ? dayjs(val).format('YYYY-MM-DD HH:mm') : '')
    }
  ]

  private open () {
    // if (!this.data.orderInfo) return
    // this.tableData.list = this.data.orderInfo.feesDetails
    // this.tableData.totalCount = this.data.orderInfo.feesDetails.length
  }
}
